import { render, staticRenderFns } from "./list-evaluate.vue?vue&type=template&id=023bc606&scoped=true"
import script from "./list-evaluate.vue?vue&type=script&lang=js"
export * from "./list-evaluate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "023bc606",
  null
  
)

export default component.exports